import { useCallback, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { LoadingErrorHint } from '$components/loading-error-hint/loading-error-hint';
import { DeleteReportConfirmWrapper } from '$features/report-hub/components/delete-report-confirm-wrapper';
import {
  useDownloadReport,
  useGetStabilityReport,
} from '$features/report-hub/report-hub.api';
import { StabilityReportDetail } from '$features/report-hub/stability-report/stability-report-detail';

export function StabilityReportDetailWrap() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const reportId = searchParams.get('id');
  const { data: report } = useGetStabilityReport(reportId);
  const downloadReportMutation = useDownloadReport();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleDownload = useCallback(async () => {
    if (!reportId) return;
    try {
      const downloadUrl = await downloadReportMutation.mutateAsync(reportId);
      window.open(downloadUrl, '_blank');
    } catch {
      // silently fail
    }
  }, [downloadReportMutation, reportId]);

  const handleDeleteSuccess = useCallback(() => {
    navigate({ search: '' });
  }, [navigate]);

  if (!report) return <LoadingErrorHint className="m-top-xl" />;

  return (
    <>
      <StabilityReportDetail
        report={report}
        onDelete={() => setIsDeleteDialogOpen(true)}
        onDownload={handleDownload}
        isDownloading={downloadReportMutation.isPending}
      />
      <DeleteReportConfirmWrapper
        isDeleteConfirmOpen={isDeleteDialogOpen}
        onOpenChange={setIsDeleteDialogOpen}
        selectedReport={report}
        onDeleteSuccess={handleDeleteSuccess}
      />
    </>
  );
}
